var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-agregar",attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[(_vm.icon != null)?_c('i',{class:'fa ' + _vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }